import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserCRM extends Layout {
    checkboxAllContacts: Checkbox;
    checkboxQuoteCompActCreate: Checkbox;
    checkboxQuotePendActCreate: Checkbox;
    panelQuickQuoteCompleted: Panel;
    panelQuickQuotePending: Panel;
    sourceUserSettings: DataSource;
    textboxCallListProfile: Textbox;
    textboxQuoteCompActId: Textbox;
    textboxQuotePendActId: Textbox;
}
